<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="购销全流程">
              <a-select
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                show-search
                allow-clear
                v-model="queryParam.project_id"
                placeholder="请输入名称"
                :default-active-first-option="false"
                @search="this.projectSearch"
                @change="handleProjectChange"
              >
                <a-select-option v-for="d in projectList" :key="d.id">
                  {{ d.name }}（{{ d.number }}）
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="类型">
              <div class="custom-select-container">
                <a-select
                  allow-clear
                  placeholder="类型"
                  v-model="queryParam.type"
                >
                  <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.trade_cost_type">{{ val }}</a-select-option>
                </a-select>
              </div>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
          <a-col :md="2" :sm="24" v-if="false">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleArchived">批量存档</a-button>
            </span>
          </a-col>
          <a-col :md="4" :sm="24" v-if="true">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="handleAdd">新建</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200}"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <div slot="money_render" slot-scope="text" style="text-align: right; min-width: 100px; max-width: 150px">
        {{ text | numberFormat }}
      </div>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="archived" slot-scope="text, item">
        <a-popconfirm
          title="确定存档吗?"
          :disabled="text"
          @confirm="() => archived(item)">
          <a-switch checked-children="是" un-checked-children="否" :checked="item.is_archived" :disabled="item.is_archived"/>
        </a-popconfirm>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleAttachment(record)">附件</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a @click="handleEdit(record)" v-if="isEdited(record.create_by_id)">编辑</a>
          <a-divider type="vertical" v-if="isEdited(record.create_by_id)"/>
          <a-popconfirm
            v-if="isEdited(record.create_by_id)"
            title="确定要删除么？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleDelete(record)"
          >
            <a>删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <create-form
      ref="createModal"
      v-if="visible"
      :visible="visible"
      :loading="confirmLoading"
      :model="mdl"
      @cancel="handleAddCancel"
      @ok="handleOk"
    />
    <archived-form
      ref="archivedModal"
      :visible="archived_visible"
      @cancel="handleArchivedCancel"
      @ok="handleArchivedOK"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import {
  project_cost_list,
  project_cost_create,
  project_cost_delete,
  project_cost_archived
} from '@/api/trade_project_cost'
import CreateForm from '../modules/CreateForm'
import ArchivedForm from '../modules/ArchivedForm'
import { project_list } from '@/api/trade_project'
import debounce from 'lodash/debounce'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm,
    ArchivedForm
  },
  data () {
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      loading: false,
      confirmLoading: false,
      // 创建窗口控制
      visible: false,
      archived_visible: false,
      projectList: [],
      mdl: {},
      // 查询参数
      queryParam: {
        project_id: undefined,
        type: undefined
      },
      // 表头
      columns: [
        {
          title: '序号',
          width: 50,
          fixed: 'left',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '购销全流程',
          dataIndex: 'project',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '编号',
          dataIndex: 'number',
          width: 150,
          fixed: 'left',
          ellipsis: true
        },
        {
          title: '类型',
          dataIndex: 'type',
          ellipsis: true,
          width: 120,
          align: 'center',
          customRender: (text) => this.$Dictionaries.trade_cost_type[text] ? this.$Dictionaries.trade_cost_type[text] : '未知'
        },
        {
          title: '成本',
          dataIndex: 'amount_cny',
          width: 150,
          ellipsis: true,
          align: 'right',
          scopedSlots: { customRender: 'money_render' }
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: 200,
          ellipsis: true
        },
        {
          title: '已存档',
          dataIndex: 'is_archived',
          align: 'center',
          width: 150,
          scopedSlots: { customRender: 'archived' }
        },
        {
          title: '创建人',
          dataIndex: 'create_by',
          width: 150,
          ellipsis: true
        },
        {
          title: '时间',
          dataIndex: 'create_time',
          width: 180
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '210px',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return project_cost_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: [],

      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          getCheckboxProps: record => ({
            props: {
              disabled: record.is_archived
            }
          }),
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: false
    }
  },
  created () {
    this.tableOption()
    if (this.$route.query && this.$route.query.id) {
      this.queryParam['id'] = this.$route.query.id
    }
  },
  computed: {
    isEdited () {
      return (create_by_id) => {
        const info = this.$store.state.user.info
        return create_by_id === info.id || create_by_id === -1
      }
    }
  },
  methods: {
    handleProjectSearch (value) {
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      }
    },
    tableOption () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            getCheckboxProps: record => ({
              props: {
                disabled: record.is_archived
              }
            }),
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleAdd () {
      const date = new Date()
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : '0' + (date.getMonth() + 1)
      const day = date.getDate() > 9 ? date.getDate() : '0' + date.getDate()
      const hours = date.getHours() > 9 ? date.getHours() : '0' + date.getHours()
      // const minutes = date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()
      // const second = date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds()
      this.mdl = { number: year + '' + month + '' + day + '' + hours }
      this.visible = true
    },
    handleArchived () {
      if (this.selectedRowKeys.length > 0) {
        this.archived_visible = true
      } else {
        this.$message.info('选择存档记录')
      }
    },
    handleAddCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleArchivedCancel () {
      this.archived_visible = false
      const form = this.$refs.archivedModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleAttachment (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project_cost/' + record.id + '/attachment', query: { record: record.name } })
    },
    handleEdit (record) {
      // this.$emit('onEdit', record)
      this.$router.push({ path: '/trade/project_cost/' + record.id })
    },
    handleDelete (record) {
      project_cost_delete(record.id).then((res) => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    archived (record) {
      project_cost_archived({ id: record.id, is_archived: !record.is_archived }).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleOk (date) {
      const form = this.$refs.createModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          console.log('values', values)
            // 新增
          values.date = undefined
          values.start_date = date.start_date
          values.end_date = date.end_date
          project_cost_create(values).then(res => {
              this.visible = false
              // 重置表单数据
              form.resetFields()
              // 刷新表格
              if (res.code === 1000) {
                this.$refs.table.refresh()
              }
          }).finally(() => {
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleArchivedOK () {
      const form = this.$refs.archivedModal.form
      this.confirmLoading = true
      form.validateFields((errors, values) => {
        if (!errors) {
          const data = {
            ids: this.selectedRowKeys,
            ...values
          }
          project_cost_archived(data).then(res => {
            // 刷新表格
            if (res.code === 1000) {
              this.$refs.table.refresh()
            }
          }).finally(() => {
            this.archived_visible = false
            this.confirmLoading = false
          })
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>
